import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '分类', path: '/category/romance' },
  { name: '排行榜', path: '/category/action' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-100/95 backdrop-blur-md shadow-[0_1px_0_oklch(var(--background-200))]'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex items-center justify-between px-4 md:px-6 py-3">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="香香漫画首页">
          <span className="font-heading text-2xl text-primary-500 tracking-wide">香香漫画</span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`whitespace-nowrap text-sm transition-colors duration-200 hover:text-primary-500 ${
                location.pathname === link.path
                  ? 'text-primary-500 font-semibold'
                  : 'text-foreground-600'
              }`}
            >
              {link.name}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-4">
          <button
            className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-200 text-foreground-600 text-sm hover:bg-background-300 transition-colors whitespace-nowrap cursor-pointer"
            aria-label="搜索漫画"
          >
            <i className="ri-search-line text-base w-4 h-4 flex items-center justify-center"></i>
            <span>搜索</span>
          </button>
        </div>

        <button
          className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-100 border-t border-background-200 px-4 py-4 flex flex-col gap-3 animate-in slide-in-from-top-2">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`whitespace-nowrap text-sm py-2 transition-colors ${
                location.pathname === link.path
                  ? 'text-primary-500 font-semibold'
                  : 'text-foreground-600'
              }`}
            >
              {link.name}
            </Link>
          ))}
          <div className="flex items-center gap-2 pt-2 border-t border-background-200">
            <i className="ri-search-line text-base text-foreground-500"></i>
            <span className="text-sm text-foreground-500">搜索漫画...</span>
          </div>
        </div>
      )}
    </nav>
  );
}